import type { AssignmentFormData } from '../../../types/assignmentTypes';
import SettingsFormPreview from '../SettingsFormPreview';
import { useFormContext } from 'react-hook-form';

export default function SettingsFormPreviewWrapper() {
  const { watch } = useFormContext<AssignmentFormData>();

  const { useCustomDueDate, customDueDate, settings, setDueDate, useAssignmentDelay } = watch();

  return (
    <SettingsFormPreview
      settings={settings}
      useCustomDueDate={useCustomDueDate}
      customDueDate={customDueDate}
      useDueDate={setDueDate}
      useAssignmentDelay={useAssignmentDelay}
      renderStatus
    />
  );
}
